import { Input, Label } from "@twilio-paste/core";

import { Field } from "../../store/definitions";

type PhoneFieldProps = {
    field: Field;
    onChange?: (newValue: string) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLElement>) => void;
    value?: string;
};

export const PhoneField = ({ field, onChange, onKeyPress, value }: PhoneFieldProps) => {
    const { name, label, placeholder, required } = field;

    return (
        <>
            <Label htmlFor={name}>{label}</Label>
            <Input
                type="tel"
                placeholder={placeholder}
                name={name}
                id={name}
                value={value ?? ""}
                onChange={(e) => onChange?.(e.target.value)}
                required={required}
                onKeyPress={(e) => onKeyPress?.(e)}
            />
        </>
    );
};
